import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserInfo } from '../redux/actions';
import { selectUser, selectUserLoading } from '../redux/selectors';
import { tokenStorage } from '../utils';

export const useAuth = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const loading = useSelector(selectUserLoading);

  useEffect(() => {
    // Проверяем наличие токена при загрузке приложения
    const token = tokenStorage.get();
    if (token && !user && !loading) {
      dispatch(fetchUserInfo());
    }
  }, [dispatch, user, loading]);

  return {
    user,
    loading,
    isAuthenticated: !!user,
  };
};
